import { Organization } from "../../../models/organization.model.ts";
import { OrganizationSerializer } from "../../../models/serializers/organizationSerializer.ts";
import { httpRequest } from "../../http";

export class CommandCreateOrganization {
    async run(organization: Organization) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/`
        const body: Record<string, unknown> = {
            name: organization.name,
            site_url: organization.site_url,
            description: organization.description,
            create_date: new Date(),
            update_date: new Date()
        }
        if (organization.parent_id != null) {
            body.parent_id = organization.parent_id;
        }
        try {
            const response = await httpRequest<any>(url, { method: "POST", body });
            if(response) {
                return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Organization{
        const serializer = new OrganizationSerializer();
        return serializer.deserialize(data);
    }
}



